module.exports = __webpack_public_path__ + "static/img/apply3.331a7496.png";